import styled from 'styled-components';
import { gridSizes, media } from 'utils/style';

import Footer from './Footer';

export default styled(Footer)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${gridSizes('L')} 0;

  ${media.lessThan('extraSmall')`
        padding: ${gridSizes('M')};

        background: #fff;
        border-radius: 2px;
        margin: 4px;

        button {
          width: 100%;
        }
  `};

  span.buttonLabel {
    margin-right: ${gridSizes('S')};
  }

  @media print {
    display: none;
  }

  .print-btn {
    button {
      border: solid 1px var(--grey300);
      color: var(--grey800);
      border-radius: 4px;
      display: flex;

      .btnWrapper {
        align-items: center;
      }

      svg {
        margin: 0 0.6rem 0 0;
        width: 12px;
        height: 12px;
        fill: var(--grey800);
      }

      &:hover {
        background-color: transparent;
        border: solid 1px var(--grey500);
        color: var(--grey900);
        svg {
          fill: var(--grey900);
        }
      }
    }
  }
`;
